import { Routes } from '@angular/router';
import { BlogDetailComponent } from './blog-detail/blog-detail.component';
import { BlogListComponent } from './blog-list/blog-list.component';

export const blogRoutes: Routes = [
  { path: '', component: BlogListComponent },
  {
    path: ':slug',
    component: BlogDetailComponent,
    data: { prerender: true }
  }
];

export async function getPrerenderParams(): Promise<Record<string, string>[]> {
  return [
    { slug: 'willkommen' },
    { slug: 'angular-tipps' },
    { slug: 'clean-architecture' },
    { slug: 'cqrs-event-sourcing-angular' },
    { slug: 'domain-driven-design-angular' },
    { slug: 'advanced-testing-angular' },
    { slug: 'angular-signals-enterprise' },
    { slug: 'signalstore-advanced-angular' },
    { slug: 'component-architecture-angular' },
    { slug: 'internationalisierung-angular' },
    { slug: 'angular-forms-reactive-vs-signals' },
    { slug: 'angular-highcharts-visualisierungen' },
    { slug: 'angular-pdf-export-reports' },
    { slug: 'angular-performance-optimization' },
    { slug: 'angular-architektur-playbook' },
    { slug: 'angular-ai-gpt-integration' },
    { slug: 'angular-security-auth-roles' },
    { slug: 'nx-monorepo-deep-dive' },
    { slug: 'angular-headless-cms-integration' },
    { slug: 'angular-smart-search' },
    { slug: 'angular-admin-dashboards' },
    { slug: 'angular-multistep-forms' },
    { slug: 'signals-rxjs-combo' },
    { slug: 'angular-knowledge-graph' },
    { slug: 'angular-architecture-faq' },
    { slug: 'angular-feature-shells' },
    { slug: 'angular-signals-patterns' },
    { slug: 'angular-projektstart-playbook' },
    { slug: 'angular-clean-code' },
    { slug: 'angular-build-optimization' },
    { slug: 'angular-analytics-tracking' },
    { slug: 'angular-business-dashboards' },
    { slug: 'angular-cicd-workflow' },
    { slug: 'angular-ecommerce-grundlagen' },
    { slug: 'angular-hiring-guide' },
    { slug: 'angular-libraries-structure' },
    { slug: 'angular-microfrontends' },
    { slug: 'angular-state-management-2025' },
    { slug: 'angular-plugin-architecture' },
    { slug: 'angular-content-projection' },
    { slug: 'angular-charting-libraries' },
    { slug: 'angular-knowledge-transfer' },
    { slug: 'angular-deployment-cicd' },
    { slug: 'angular-auth-strategies' },
    { slug: 'angular-module-structure' },
    { slug: 'angular-observability' },
    { slug: 'angular-api-integration' },
    { slug: 'angular-change-detection' },
    { slug: 'angular-component-testing' },
    { slug: 'angular-control-flow' },
    { slug: 'angular-dependency-injection' },
    { slug: 'angular-directives-deep-dive' },
    { slug: 'angular-direktiven' },
    { slug: 'angular-feature-flags' },
    { slug: 'angular-folder-file-structure' },
    { slug: 'angular-forms-advanced' },
    { slug: 'angular-inputs-outputs' },
    { slug: 'angular-layouts' },
    { slug: 'angular-library-best-practices' },
    { slug: 'angular-lifecycle-hooks' },
    { slug: 'angular-lifecycle' },
    { slug: 'angular-module-federation' },
    { slug: 'angular-pipes' },
    { slug: 'angular-project-maturity' },
    { slug: 'angular-routing-advanced' },
    { slug: 'angular-services-backbone' },
    { slug: 'angular-signals-computed-effect' },
    { slug: 'angular-signals-deep-dive' },
    { slug: 'angular-signals-rxjs-kombi' },
    { slug: 'angular-style-guide-2025' },
    { slug: 'angular-theming' },
    { slug: 'angular-unit-testing-best-practices' },
    { slug: 'angular-zone-free' },
    { slug: 'angular-zone-free-development' }
  ];
}
